export function createBlankTicket(amount: string, employeePin?: string) {
  const amountNumber = Number(amount.replace(/[^0-9.]/g, ""));
  return {
    ticket: {
      id: "",
      ticket_code: "",
      restaurant_identifier: "",
      name: "",
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      delivery: {},
      delivery_fee: 0.0,
      service_charges: [],
      taxes: [
        {
          tax_name: "DEFAULT TAX",
          display_amount: 0,
        },
      ],
      sub_total: amountNumber,
      tax_total: 0.0,
      bill_total: amountNumber,
      prepaid_amount: 0.0,
      prepaid_tips: 0.0,
      requested_pay_amount: null,
      tip_calculation_base: amountNumber,
      bill_amount_due: amountNumber,
      bill_amount_to_leave_unpaid: 0.0,
      bill_amount: amountNumber,
      bill_card_amount: 0.0,
      bill_house_account_amount: 0.0,
      line_items: [],
      item_offers: [],
      table: [],
      discounts: [],
      order_level_discount_amount: null,
      total_discount_amount: null,
      employee_pin: employeePin,
    },
  };
}
